import React, { useState, useEffect } from 'react';
import './DashboardNavigation.css';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import DashboardSidebar from './DashboardSidebar/DashboardSidebar';
import DashboardHeader from './DashboardHeader/DashboardHeader';
import RecordsSidebar from './Records/RecordsSidebar/RecordComponents/RecordsSidebar';
import PastAppointment from './DoctorNotes/PastAppointment';
import { useApp } from '../../AppProvider';
import AlertPopUp from '../../Components/AlertPopUp/AlertPopUp';

const DashboardNavigation = () => {
    const { pastSidebarToggle, selectedPatientObj } = useApp();
    const location = useLocation();
    const path = location.pathname;
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if (selectedPatientObj === undefined || selectedPatientObj === null) {
            setShowPopup(true);
        } else {
            setShowPopup(false);
        }
    }, [selectedPatientObj]);

    const isHistoryRoute = path.startsWith('/DashboardDashboardNavigation');
    const isDoctorNotesRoute = path.startsWith('/DashboardDashboardNavigation/doctornotes');
    const isRecordRoute = path.startsWith('/DashboardDashboardNavigation/records');
    const isDataVizualizationRoute = path.startsWith('/DashboardDashboardNavigation/visualization');

    return (
        <div className="dashboadrNavigation_container">
            {showPopup && (
                <AlertPopUp
                    open={showPopup}
                    title="Patient Required"
                    message="Please go to Home and select a patient before accessing the dashboard."
                    buttonText="Go to Home"
                    navigateTo="/"
                />
            )}
            {!isDoctorNotesRoute && !isRecordRoute && isHistoryRoute && !isDataVizualizationRoute && <DashboardSidebar />}
            {isDoctorNotesRoute ? (pastSidebarToggle ? <PastAppointment /> : <DashboardSidebar />) : null}
            {isRecordRoute ? <RecordsSidebar /> : null}
            <div className="dashboard-section-navigation">
                <DashboardHeader />
                <Outlet />
            </div>
        </div>
    )
}

export default DashboardNavigation;
